<template>
  <div>
    <script :id=id type="text/plain"></script>
  </div>
</template>
<script>
  export default {
    name: 'UE',
    data () {
      return {
        editor: null,
        isLoad: false
      }
    },
    props: {
      defaultMsg: {
        type: String
      },
      config: {
        type: Object
      },
      id: {
        type: String
      },
    },
    methods: {
      getUEContent() { // 获取内容方法
        return this.editor.getContent()
      },
      getUEContentTxt() { // 获取纯文本内容方法
        return this.editor.getContentTxt()
      },
      setDefaultContent (msg) {
        this.editor && this.editor.setContent(msg);
      }
    },
    mounted () {
      this.editor = UE.getEditor(this.id, this.config); // 初始化UE
      this.editor.addListener("ready", () => {
        this.isLoad = true
         this.setDefaultContent(this.defaultMsg)// 确保UE加载完成后，放入内容。
      });
    },
    destroyed() {
      this.editor.destroy();
    },
    watch: {
      defaultMsg: {
        handler (val) {
          this.isLoad && this.setDefaultContent(val)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/public/edit-plan-sub/ue.vue